import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { DashboardRes } from 'features/dashboard'
import { AuthContext } from 'store'
import { useContext } from 'react'
import { queryKeys } from 'config/queryKeys'

export const useFetchDashboardData = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const {
		data: dashboardData,
		isLoading: isDashboardDataLoading,
		isSuccess: isDashboardDataSuccess
	} = useQuery<DashboardRes>({
		queryKey: queryKeys.dashboard.all,
		queryFn: () => axiosPrivate.get(apiRoutes.dashboard),
		enabled: !!auth.accessToken
	})

	return {
		dashboardData,
		isDashboardDataLoading,
		isDashboardDataSuccess
	}
}
